import React, { SyntheticEvent, useState } from 'react';
import { useFormikContext } from 'formik';
import { Autocomplete, createFilterOptions, AutocompleteProps } from '@mui/material';
import TextField, { TextFieldProps } from '@mui/material/TextField';

const OPTIONS_LIMIT = 150;
const filterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT,
});

type ComboBoxProps = {
    name: string;
    required: boolean | undefined;
};

const ComboBox = (
    props: JSX.IntrinsicAttributes & AutocompleteProps<any, any, any, any> & TextFieldProps & ComboBoxProps,
) => {
    const [inputValue, setInputValue] = useState('');
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if (inputValue.length > 0) {
            setOpen(true);
        }
    };
    const handleInputChange = (event: SyntheticEvent, newInputValue: string, reason: string) => {
        setInputValue(newInputValue);
        if (newInputValue.length > 0 && reason === 'input') {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };
    const { options, error = false, label, name, defaultValue } = props;
    const { setFieldValue } = useFormikContext();
    return (
        <Autocomplete
            filterOptions={filterOptions}
            id="combo-box-demo"
            open={open}
            freeSolo
            onOpen={handleOpen}
            onClose={() => setOpen(false)}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            value={defaultValue}
            options={options}
            getOptionLabel={(option) => option.label || ''}
            onChange={(e, val) => setFieldValue(name, val)}
            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                <TextField {...params} error={error} required={props.required} label={label} />
            )}
        />
    );
};

export default ComboBox;
